var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDataLoading)?_c('Loader'):_c('div',{staticClass:"container"},[_c('div',{staticClass:"wysiwyg",domProps:{"innerHTML":_vm._s(_vm.cgu)}})])}
var staticRenderFns = []

export { render, staticRenderFns }